module.exports = __webpack_public_path__ + "img/hot.6109838b.svg";